import { AccommodationType, Airline, City, Country, TransportType } from 'model/business-keywords';

export interface CitySegment {
  kind: 'city-segment';
  city: City | null;
  arrivalDate: string | null;
  departureDate: string | null;
  country?: Country;
}

export interface TransportSegment {
  kind: 'transport-segment';
  type: TransportType | null;
  airline: Airline | null;
  airlineName: string | null;
  flightNumber: string | null;
  departureDate: string | null;
  note: string | null;
}

export interface AccommodationSegment {
  kind: 'accommodation-segment';
  type: AccommodationType | null;
  name: string | null;
  address: string | null;
  city: City | null;
  cityName: string | null;
  country: Country | null;
  arrivalDate: string | null;
  departureDate: string | null;
}

export interface NoteSegment {
  kind: 'note-segment';
  note: string | null;
}

export type TravelSegment = CitySegment | TransportSegment | AccommodationSegment | NoteSegment;

export function initCitySegment(data?: Partial<CitySegment>): CitySegment {
  return { kind: 'city-segment', city: null, arrivalDate: null, departureDate: null, country: null, ...data };
}

export function initTransportSegment(data?: Partial<TransportSegment>): TransportSegment {
  return { kind: 'transport-segment', type: null, airline: null, airlineName: null, flightNumber: null, departureDate: null, note: null, ...data };
}

export function initAccommodationSegment(data?: Partial<AccommodationSegment>): AccommodationSegment {
  return { kind: 'accommodation-segment', type: null, name: null, address: null, city: null, cityName: null, country: null, arrivalDate: null, departureDate: null, ...data };
}

export function initNoteSegment(data?: Partial<NoteSegment>): NoteSegment {
  return { kind: 'note-segment', note: null, ...data };
}

export function produceBaseSegments(transportType?: TransportType, accommodationType?: AccommodationType, country?: Country): TravelSegment[] {
  return [initCitySegment({ country: country }), initTransportSegment({ type: transportType }), initAccommodationSegment({ type: accommodationType, country: country })];
}

export function extractTripCountries(segments: TravelSegment[]) {
  return segments.map(s => { switch (s.kind) { case 'city-segment': return s.city?.country ?? s.country; case 'accommodation-segment': return s.country ?? s.city?.country; } }).filter((curr, i, all) => curr != null && !all.slice(0, i).some(prev => prev?.id === curr.id));
}
